import {Matrix4, Vector3} from "@cm/math"
import type {BoundsEdgeDimension, BoundsEdgeNumber} from "#template/utils/scene-geometry-utils"

const DimensionGuideBoxTypename = "DimensionGuideBox"

export const indexToDirection = (index: number): BoundsEdgeDimension => {
    switch (index) {
        case 0:
            return "x"
        case 1:
            return "y"
        case 2:
            return "z"
        default:
            throw new Error("Invalid index")
    }
}

export const getBoundsEdgeTransform = (dir: BoundsEdgeDimension, number: BoundsEdgeNumber, offset: number): Matrix4 => {
    const translation = new Vector3(0, 0, 0)

    switch (dir) {
        case "x":
            translation.y = number < 2 ? -offset : offset
            translation.z = number % 2 ? offset : -offset
            break
        case "y":
            translation.x = number < 2 ? -offset : offset
            translation.y = number % 2 ? offset : -offset
            break
        case "z":
            translation.x = number < 2 ? -offset : offset
            translation.z = number % 2 ? offset : -offset
            break
    }

    const result = Matrix4.identity()
    result.setTranslation(translation)
    return result
}

const dimensionGuideBoxIdRegex = new RegExp(`${DimensionGuideBoxTypename}@\\d+$`)

export const idBelongsToDimensionGuideBox = (id: string): boolean => {
    return dimensionGuideBoxIdRegex.test(id)
}
